var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCutlery02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 449,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.664,
    cy: 257.326,
    r: 133.605,
    transform: "rotate(135 192.664 257.326)",
    stroke: "#D7DBDE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.507,
    cy: 256.482,
    r: 84.696,
    transform: "rotate(135 193.507 256.482)",
    stroke: "#D7DBDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.953 146.468c2.824 2.711 4.024 6.742 2.986 10.526-4.179 15.228 2.961 36.158 19.409 52.606 21.277 21.277 50.061 26.989 64.29 12.759 14.231-14.229 8.518-43.013-12.759-64.29-16.448-16.448-37.378-23.588-52.606-19.41-3.784 1.039-7.815-.162-10.525-2.986L239.308 24.785c-2.818-2.937-7.506-2.977-10.393-.09l-4.941 4.94c-2.887 2.888-2.846 7.576.09 10.394l110.889 106.439z",
    stroke: "#D7DBDE"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQ5IiBoZWlnaHQ9IjQ0OSIgdmlld0JveD0iMCAwIDQ0OSA0NDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSIxOTIuNjY0IiBjeT0iMjU3LjMyNiIgcj0iMTMzLjYwNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTM1IDE5Mi42NjQgMjU3LjMyNikiIHN0cm9rZT0iI0Q3REJERSIvPgogICAgPGNpcmNsZSBjeD0iMTkzLjUwNyIgY3k9IjI1Ni40ODIiIHI9Ijg0LjY5NjIiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxOTMuNTA3IDI1Ni40ODIpIiBzdHJva2U9IiNEN0RCREUiLz4KICAgIDxwYXRoIGQ9Ik0zMzQuOTUzIDE0Ni40NjhDMzM3Ljc3NyAxNDkuMTc5IDMzOC45NzcgMTUzLjIxIDMzNy45MzkgMTU2Ljk5NEMzMzMuNzYgMTcyLjIyMiAzNDAuOSAxOTMuMTUyIDM1Ny4zNDggMjA5LjZDMzc4LjYyNSAyMzAuODc3IDQwNy40MDkgMjM2LjU4OSA0MjEuNjM4IDIyMi4zNTlDNDM1Ljg2OSAyMDguMTMgNDMwLjE1NiAxNzkuMzQ2IDQwOC44NzkgMTU4LjA2OUMzOTIuNDMxIDE0MS42MjEgMzcxLjUwMSAxMzQuNDgxIDM1Ni4yNzMgMTM4LjY1OUMzNTIuNDg5IDEzOS42OTggMzQ4LjQ1OCAxMzguNDk3IDM0NS43NDggMTM1LjY3M0wyMzkuMzA4IDI0Ljc4NDVDMjM2LjQ5IDIxLjg0NzkgMjMxLjgwMiAyMS44MDc3IDIyOC45MTUgMjQuNjk0OUwyMjMuOTc0IDI5LjYzNTVDMjIxLjA4NyAzMi41MjI3IDIyMS4xMjggMzcuMjEwNyAyMjQuMDY0IDQwLjAyOTFMMzM0Ljk1MyAxNDYuNDY4WiIgc3Ryb2tlPSIjRDdEQkRFIi8+Cjwvc3ZnPgo=";
export { SvgCutlery02 as ReactComponent };